<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="话机管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="话机编号">
          <el-input size="mini" v-model="params.PhoneCode" placeholder="请填写话机编号" clearable />
        </el-form-item>
        <el-form-item label="话机号码">
          <el-input size="mini" v-model="params.PhoneNo" type="number" placeholder="请填写话机号码" clearable />
        </el-form-item>
        <el-form-item label="位置类型">
          <el-select size="mini" v-model="params.LocationType" clearable>
            <el-option value="室内"/>
            <el-option value="室外"/>
          </el-select>
        </el-form-item>
        <el-form-item label="校区">
          <el-input size="mini" v-model="params.SchoolArea" placeholder="请填写校区" clearable />
        </el-form-item>
        <el-form-item label="地点">
          <el-input size="mini" v-model="params.Place" placeholder="请填写地点" clearable />
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select size="mini" v-model="params.Status" clearable>
            <el-option value="1" label="启用"/>
            <el-option value="0" label="禁用"/>
          </el-select>
        </el-form-item>
        <el-form-item label="连接状态">
          <el-select size="mini" v-model="params.ConnectStatus" clearable>
            <el-option value="1" label="正常"/>
            <el-option value="0" label="异常"/>
          </el-select>
        </el-form-item>
        <el-form-item label="IMEI">
          <el-input size="mini" v-model="params.Imei" placeholder="请填写IMEI" clearable />
        </el-form-item>
        <el-form-item label="通话时长设置结果" class="long-query">
          <el-select size="mini" v-model="params.UpperLimitRlt" clearable>
            <el-option value="等待设置" />
            <el-option value="已请求设置" />
            <el-option value="设置成功" />
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="PhoneCode" label="话机编号" min-width="100"/>
        <el-table-column prop="PhoneNo" label="话机号码" min-width="110"/>
        <el-table-column prop="SchoolArea" label="校区" min-width="120"/>
        <el-table-column prop="Place" label="地点" min-width="150" />
        <el-table-column prop="UpperLimit" label="通话时长上限(分钟)" min-width="150" />
        <el-table-column prop="UpperLimitRlt" label="通话时长设置结果" min-width="120"/>
        <el-table-column prop="DayMinutes" label="当天通话时长（分钟）" min-width="150"/>
        <el-table-column prop="TotalMinutes" label="累计通话时长（分钟）" min-width="150"/>
        <el-table-column label="启用状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status==1">启用</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="连接状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.ConnectStatus==1">正常</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="适用校讯通" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.EduToHome==1">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Imei" label="IMEI" min-width="120" align="center"/>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list,exportDialog },
  data() {
    return {
      api: require("@/api/consume/phonemanage").default,
      params: {
        // SchoolId: null,
        PhoneCode: "",
        PhoneNo: "",
        LocationType: null,
        SchoolArea: "",
        Place: "",
        Status: null,
        ConnectStatus: null,
        Imei: "",
        UpperLimitRlt: "",
      },
      // schoolList: [],
    };
  },
  methods: {
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      // this.api.export(this.$commonJs.obj.removeNullKey(this.params));
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>
<style>
.long-query .el-form-item__label{
  width: 125px;
}
</style>